import React from 'react';
import { RECIPES, INGREDIENT_CARDS, DECKS } from '../../data/balatroChef/gameData'; 

const Board = ({ balatroLogic }) => {
  const { 
    gamePhase, day, money, activeJokers, shopJokers, currentBoss,
    deck, hand, selectedCards, score, targetScore, playsLeft, discardsLeft, 
    lastPlayedRecipe, isRecipeBookOpen, 
    selectDeckAndStart, proceedToNextBlind, buyJoker, initBalatroGame,
    toggleSelectCard, discardSelected, playSelected, closePopupAndCheckGameState, toggleRecipeBook
  } = balatroLogic;

  const getIcon = (type) => {
    const card = INGREDIENT_CARDS.find(c => c.type === type);
    return card ? card.icon : '❓';
  };

  // ================= 1. หน้าจอเลือกสำรับไพ่ =================
  if (gamePhase === 'deck_select') {
    return (
      <div style={{ maxWidth: '600px', margin: '0 auto', fontFamily: 'sans-serif', padding: '40px 20px', backgroundColor: '#2f3542', minHeight: '100vh', color: 'white', textAlign: 'center' }}>
        <h1 style={{ color: '#ff4757', marginBottom: '10px' }}>เลือกสำรับไพ่วัตถุดิบ</h1>
        <p style={{ color: '#a4b0be', marginBottom: '40px' }}>สไตล์การทำอาหารของคุณเริ่มต้นที่นี่</p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {DECKS.map(d => (
            <div key={d.id} onClick={() => selectDeckAndStart(d.id)} style={{ backgroundColor: '#1e272e', border: `3px solid ${d.color}`, borderRadius: '15px', padding: '20px', cursor: 'pointer', boxShadow: `0 4px 15px ${d.color}40` }}>
              <h2 style={{ margin: '0 0 10px 0', color: d.color }}>{d.name}</h2>
              <p style={{ margin: '0 0 15px 0', fontSize: '14px', color: '#dcdde1' }}>{d.desc}</p>
              <div style={{ backgroundColor: 'rgba(0,0,0,0.3)', padding: '10px', borderRadius: '8px', display: 'inline-block' }}>
                <span style={{ fontSize: '12px', color: '#a4b0be', display: 'block', marginBottom: '5px' }}>แถมอุปกรณ์เริ่มต้น:</span>
                <span style={{ fontSize: '20px' }}>{d.startingJoker === 'j_wok' ? '🍳 กระทะเหล็ก' : d.startingJoker === 'j_charcoal' ? '♨️ เตาถ่าน' : '🥣 ครกหิน'}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // ================= 2. หน้าจอตลาด/ร้านค้า (Shop Phase) =================
  if (gamePhase === 'shop') {
    return (
      <div style={{ maxWidth: '600px', margin: '0 auto', fontFamily: 'sans-serif', padding: '40px 20px', backgroundColor: '#2f3542', minHeight: '100vh', color: 'white' }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h1 style={{ color: '#2ed573', margin: '0 0 10px 0' }}>ยอดขายทะลุเป้า! 🎉</h1>
          <p style={{ color: '#a4b0be', fontSize: '18px' }}>ยอดเงินคงเหลือของคุณ: <strong style={{ color: '#feca57', fontSize: '24px' }}>฿{money}</strong></p>
        </div>

        <h3 style={{ color: '#ff4757', borderBottom: '2px solid #57606f', paddingBottom: '10px' }}>🛒 อุปกรณ์ก้นครัว (Jokers) {activeJokers.length}/5</h3>
        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '40px' }}>
          {shopJokers.map(joker => (
            <div key={joker.id} style={{ backgroundColor: '#1e272e', padding: '15px', borderRadius: '12px', border: '2px solid #a4b0be', width: '200px', textAlign: 'center' }}>
              <div style={{ fontSize: '40px', marginBottom: '10px' }}>{joker.icon}</div>
              <h4 style={{ margin: '0 0 5px 0' }}>{joker.name}</h4>
              <p style={{ fontSize: '12px', color: '#dcdde1', minHeight: '40px' }}>{joker.desc}</p>
              <button 
                onClick={() => buyJoker(joker)}
                disabled={money < joker.price || activeJokers.length >= 5}
                style={{ width: '100%', padding: '10px', marginTop: '10px', backgroundColor: money >= joker.price && activeJokers.length < 5 ? '#ffa502' : '#57606f', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}
              >
                ซื้อ ฿{joker.price}
              </button>
            </div>
          ))}
          {shopJokers.length === 0 && <p style={{ color: '#a4b0be' }}>อุปกรณ์ขายหมดแล้ว!</p>}
        </div>

        <button onClick={proceedToNextBlind} style={{ width: '100%', padding: '20px', backgroundColor: '#3742fa', color: 'white', border: 'none', borderRadius: '12px', fontSize: '20px', fontWeight: 'bold', cursor: 'pointer', boxShadow: '0 6px 0 #192a56' }}>
          ลุยด่านต่อไป (เป้าหมาย ฿{Math.floor(targetScore * 1.5)}) 🚀
        </button>
      </div>
    );
  }

  // ================= 3. หน้าจอ Game Over =================
  if (gamePhase === 'game_over') {
    return (
      <div style={{ maxWidth: '600px', margin: '0 auto', fontFamily: 'sans-serif', padding: '40px 20px', backgroundColor: '#2f3542', minHeight: '100vh', color: 'white', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <h1 style={{ color: '#ff4757', fontSize: '48px', margin: '0 0 10px 0' }}>เจ๊ง! 📉</h1>
        <p style={{ color: '#a4b0be', fontSize: '18px', marginBottom: '40px' }}>คุณไปถึงแค่วันที่ {day} <br/>ทำยอดขายได้ ฿{score} จากเป้า ฿{targetScore}</p>
        <button onClick={initBalatroGame} style={{ padding: '20px', backgroundColor: '#2ed573', color: 'white', border: 'none', borderRadius: '12px', fontSize: '20px', fontWeight: 'bold', cursor: 'pointer' }}>
          เริ่มเล่นใหม่ 🔄
        </button>
      </div>
    );
  }

  // ================= 4. หน้ากระดานเล่นเกม (Playing Phase) =================
  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', fontFamily: 'sans-serif', padding: '20px', backgroundColor: '#2f3542', minHeight: '100vh', color: 'white', paddingBottom: '80px', position: 'relative' }}>
      
      {/* --- แถบ Joker ด้านบน --- */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '10px', justifyContent: 'center' }}>
        {activeJokers.map(joker => (
          <div key={joker.id} style={{ backgroundColor: '#ff9f43', color: '#2f3542', padding: '5px 10px', borderRadius: '8px', border: '2px solid #ee5253', display: 'flex', alignItems: 'center', gap: '5px', boxShadow: '0 4px 6px rgba(0,0,0,0.3)' }}>
            <span style={{ fontSize: '18px' }}>{joker.icon}</span>
            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>{joker.name}</span>
          </div>
        ))}
      </div>

      {/* --- Header (เป้าหมายและบอส) --- */}
      <div style={{ backgroundColor: '#1e272e', padding: '20px', borderRadius: '12px', textAlign: 'center', border: `2px solid ${currentBoss.color}`, marginBottom: '20px', position: 'relative' }}>
        <div style={{ backgroundColor: currentBoss.color, color: 'white', padding: '5px', borderRadius: '8px', marginBottom: '10px', fontSize: '12px', fontWeight: 'bold' }}>
          ด่านที่ {day} | {currentBoss.name}: {currentBoss.desc}
        </div>
        
        <button onClick={toggleRecipeBook} style={{ position: 'absolute', top: '10px', right: '10px', backgroundColor: '#3742fa', color: 'white', border: 'none', padding: '8px 12px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
          📖 ดูตำรา
        </button>

        <h3 style={{ margin: '0 0 10px 0', color: '#a4b0be' }}>เป้าหมาย: ฿{targetScore}</h3>
        <h1 style={{ margin: 0, fontSize: '48px', color: '#ff4757' }}>฿{score}</h1>
        
        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '15px' }}>
          <span style={{ backgroundColor: '#3742fa', padding: '5px 15px', borderRadius: '20px', fontWeight: 'bold', fontSize: '14px' }}>ปรุงได้: {playsLeft}</span>
          <span style={{ backgroundColor: '#eccc68', color: '#2f3542', padding: '5px 15px', borderRadius: '20px', fontWeight: 'bold', fontSize: '14px' }}>ทิ้งได้: {discardsLeft}</span>
        </div>
      </div>

      {/* --- ไพ่ที่ถูกเลือก --- */}
      <div style={{ height: '140px', display: 'flex', justifyContent: 'center', alignItems: 'flex-end', gap: '10px', marginBottom: '20px' }}>
        {selectedCards.map(handIndex => {
          const card = hand[handIndex];
          if (!card) return null;
          return (
            <div key={`sel-${handIndex}`} style={{ width: '70px', height: '110px', backgroundColor: '#f1f2f6', color: '#2f3542', borderRadius: '8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', border: '2px solid #3742fa', boxShadow: '0 0 15px rgba(55, 66, 250, 0.5)' }}>
              <span style={{ fontSize: '28px' }}>{card.icon}</span>
              <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'center', padding: '0 2px' }}>{card.name}</span>
            </div>
          );
        })}
      </div>

      {/* --- ปุ่ม Action --- */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '30px' }}>
        <button onClick={playSelected} disabled={selectedCards.length === 0 || playsLeft === 0} style={{ padding: '15px 30px', fontSize: '18px', fontWeight: 'bold', borderRadius: '8px', border: 'none', backgroundColor: selectedCards.length > 0 && playsLeft > 0 ? '#2ed573' : '#57606f', color: 'white', cursor: selectedCards.length > 0 && playsLeft > 0 ? 'pointer' : 'not-allowed' }}>
          🍳 ปรุงอาหาร!
        </button>
        <button onClick={discardSelected} disabled={selectedCards.length === 0 || discardsLeft === 0} style={{ padding: '15px 30px', fontSize: '18px', fontWeight: 'bold', borderRadius: '8px', border: 'none', backgroundColor: selectedCards.length > 0 && discardsLeft > 0 ? '#ff6348' : '#57606f', color: 'white', cursor: selectedCards.length > 0 && discardsLeft > 0 ? 'pointer' : 'not-allowed' }}>
          🗑️ ทิ้งวัตถุดิบ
        </button>
      </div>

      {/* --- ไพ่บนมือ --- */}
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
          <span style={{ color: '#a4b0be', fontSize: '14px' }}>ไพ่บนมือ ({hand.length}/8)</span>
          <span style={{ color: '#a4b0be', fontSize: '14px' }}>กองการ์ด: {deck.length} ใบ</span>
        </div>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'center' }}>
          {hand.map((card, index) => {
            const isSelected = selectedCards.includes(index);
            return (
              <div key={card.uid} onClick={() => toggleSelectCard(index)} style={{ width: '65px', height: '95px', backgroundColor: 'white', color: '#2f3542', borderRadius: '8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', transition: 'all 0.2s', opacity: isSelected ? 0.3 : 1, transform: isSelected ? 'translateY(-10px)' : 'translateY(0)' }}>
                <span style={{ fontSize: '24px' }}>{card.icon}</span>
                <span style={{ fontSize: '9px', fontWeight: 'bold', textAlign: 'center' }}>{card.name}</span>
                <span style={{ fontSize: '9px', color: '#3742fa', marginTop: '2px', backgroundColor: '#f1f2f6', padding: '2px 5px', borderRadius: '10px' }}>{card.chips} 🪙</span>
              </div>
            );
          })}
        </div>
      </div>

      {/* ================= MODALS ================= */}

      {/* 📚 Modal: สมุดสูตรอาหาร */}
      {isRecipeBookOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 90, display: 'flex', flexDirection: 'column', padding: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #57606f', paddingBottom: '10px' }}>
            <h2 style={{ margin: 0, color: '#feca57' }}>📖 สมุดสูตรอาหาร</h2>
            <button onClick={toggleRecipeBook} style={{ background: 'none', border: 'none', fontSize: '24px', color: '#ff4757', cursor: 'pointer' }}>✖</button>
          </div>
          <div style={{ overflowY: 'auto', flexGrow: 1, paddingRight: '10px' }}>
            {RECIPES.map((recipe, index) => (
              <div key={recipe.id} style={{ backgroundColor: '#1e272e', border: '1px solid #57606f', padding: '15px', borderRadius: '10px', marginBottom: '15px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                  <h4 style={{ margin: 0, color: '#2ed573', fontSize: '18px' }}>{index + 1}. {recipe.name}</h4>
                  <span style={{ backgroundColor: '#3742fa', color: 'white', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold' }}>{recipe.rank}</span>
                </div>
                <div style={{ display: 'flex', gap: '5px', marginBottom: '10px' }}>
                  {recipe.required.map((req, i) => (
                    <span key={i} style={{ fontSize: '20px', backgroundColor: 'white', padding: '5px', borderRadius: '5px' }}>{getIcon(req)}</span>
                  ))}
                </div>
                <div style={{ display: 'flex', gap: '15px', fontSize: '14px', fontWeight: 'bold' }}>
                  <span style={{ color: '#34ace0' }}>ชิป: {recipe.baseChips}</span>
                  <span style={{ color: '#ff4757' }}>ตัวคูณ: x{recipe.mult}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* 🎉 Popup: โชว์ผลลัพธ์ (สับสวิตช์ปิดด้วย closePopupAndCheckGameState) */}
      {lastPlayedRecipe && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.85)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 100 }}>
          <div style={{ backgroundColor: '#ffffff', color: '#2f3542', padding: '30px', borderRadius: '15px', maxWidth: '350px', textAlign: 'center', boxShadow: '0 10px 30px rgba(0,0,0,0.5)' }}>
            <span style={{ backgroundColor: '#3742fa', color: 'white', padding: '5px 15px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>
              {lastPlayedRecipe.recipe.rank}
            </span>
            <h2 style={{ color: '#ff4757', margin: '15px 0 10px 0' }}>{lastPlayedRecipe.recipe.name}</h2>
            
            {lastPlayedRecipe.jokers && lastPlayedRecipe.jokers.length > 0 && (
              <div style={{ backgroundColor: '#fff200', padding: '5px', borderRadius: '8px', marginBottom: '10px', fontSize: '12px', fontWeight: 'bold', color: '#e55039' }}>
                {lastPlayedRecipe.jokers.map((j, i) => (
                  <div key={i}>{j.icon} {j.name} ทำงาน! ({j.msg})</div>
                ))}
              </div>
            )}

            <div style={{ backgroundColor: '#f1f2f6', padding: '15px', borderRadius: '8px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', margin: '10px 0 20px 0', fontSize: '24px', fontWeight: 'bold' }}>
              <span style={{ color: '#34ace0' }}>{lastPlayedRecipe.chips}</span>
              <span style={{ color: '#57606f', fontSize: '18px' }}>X</span>
              <span style={{ color: '#ff4757' }}>{lastPlayedRecipe.mult}</span>
            </div>
            
            <h1 style={{ color: '#2ed573', fontSize: '40px', margin: '0 0 20px 0' }}>+ ฿{lastPlayedRecipe.total}</h1>
            
            <div style={{ backgroundColor: '#fff9e6', padding: '15px', borderRadius: '8px', borderLeft: '4px solid #ffa502', textAlign: 'left', fontSize: '13px', lineHeight: '1.6', marginBottom: '20px' }}>
              💡 <strong>ความรู้:</strong> {lastPlayedRecipe.recipe.knowledge}
            </div>

            {/* ⚠️ ปรับปุ่มให้เรียกฟังก์ชันตรวจเช็กเมื่อกดปิด */}
            <button onClick={closePopupAndCheckGameState} style={{ padding: '12px 30px', backgroundColor: '#2f3542', color: 'white', border: 'none', borderRadius: '8px', fontSize: '16px', cursor: 'pointer', width: '100%' }}>
              ไปต่อ! 🚀
            </button>
          </div>
        </div>
      )}

    </div>
  );
};

export default Board;